


























import Vue from 'vue';

export default Vue.extend({
    props: {
        submit: {
            type: Boolean,
            default: false,
        },
        href: {
            type: String,
            default: null,
        },
        icon: {
            type: String,
            default: null,
        },
        textClass: {
            type: String,
            default: '',
        },
        iconClass: {
            type: String,
            default: null,
        },
        noPadding: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        computedIconClass(): string {
            return this.iconClass || ('w-6 h-6' + (this.$slots.default ? ' mr-2' : ''));
        },
    },
});
